import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FiscalService } from '../fiscal.service';
import { FiscalModel } from './fiscal.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserCompanyService } from "../../user/usercompany/usercompany.service";
import { UserCompanyModel } from "../../user/usercompany/usercompany.model";
import { ResumeService } from '../../resume/resume.service';
import { ResumeModel } from '../../resume/resume.model';
import * as FileSaver from 'file-saver';
import { CoreComponent } from '../../../core/header/core.component';
import { CoreService } from '../../../core/header/core.service';
import { UserDataModel } from '../../../core/header/userData.model';

@Component({
    selector: 'convfact-fiscal',
    templateUrl: './fiscalModel.component.html',
    styleUrls: ['../fiscal.component.css'],
    standalone: false
})

export class FiscalModelComponent implements OnInit {
    user: UserDataModel; //se quitara cuando deje de estar en alfa

    fiscalModel: FiscalModel = new FiscalModel();
    selectedTrimester: number;
    selectedModel: number;
    spinner: boolean = false;

    last_trimester: number = 0;

    casilla01: string = "0"; //Ingresos computables
    casilla02: string = "0"; //Gastos computables
    casilla03: string = "0"; //Diferencia casilla01 - casilla02
    casilla04: string = "0"; //20% de casilla 03
    casilla05: string = "0"; //Cantidad abonada en el anterior trimestre
    casilla06: string = "0"; //Retenciones IRPF ingresos trimestre 
    casilla07: string = "0"; //Diferencia 04 - 05 - 06

    constructor(
        public dialog: MatDialog,
        public resumeService: ResumeService,
        public coreService: CoreService,
        private fiscalService: FiscalService,
        private core: CoreComponent,
        public snackBar: MatSnackBar
    ) { }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    ngOnInit() {
        this.selectedTrimester = 0;
        this.selectedModel = 0;

        this.coreService.GetUserInfo().then(user => {
            this.user = user;
        });

        // this.userCompanyService.loadData().then(response => {
        //     this.userCompany = response;
        //     this.userCompanyServiceReady = true;
        // })
    }

    setTrimester() {
    }

    setModel() {
    }

    generate130() {
        // if (this.selectedTrimester == 0) {
        //     alert("Por favor seleccione un Trimestre");
        // }

        // if (this.selectedTrimester !== 0) {
        //     this.spinner = true;

        //     this.resumeService.getData(true).then(response => {
        //         this.data = response;

        //         if (this.selectedTrimester == 1) // Primer Trimestre Enero, Febrero, Marzo
        //         {
        //             this.casilla01 = (this.data['eneroI'] + this.data['febreroI'] + this.data['marzoI']).toFixed(2);
        //             this.casilla02 = (this.data['eneroG'] + this.data['febreroG'] + this.data['marzoG']).toFixed(2);
        //             this.casilla03 = ((parseFloat(this.casilla01) - parseFloat(this.casilla02)).toFixed(2)).toString();
        //             this.casilla04 = (((20 / 100) * parseFloat(this.casilla03)).toFixed(2)).toString();
        //             var tmp06 = parseFloat(this.data['eneroIRPF']) + parseFloat(this.data['febreroIRPF']) + parseFloat(this.data['marzoIRPF']);
        //             this.casilla06 = Math.abs(tmp06).toFixed(2);
        //             this.casilla07 = ((parseFloat(this.casilla04) - parseFloat(this.casilla05) - parseFloat(this.casilla06)).toFixed(2)).toString();
        //         }

        //         if (this.selectedTrimester == 2) // Segundo Trimestre Abril, Mayo, Junio
        //         {
        //             this.casilla01 = (this.data['abrilI'] + this.data['mayoI'] + this.data['junioI']).toFixed(2);
        //             this.casilla02 = (this.data['abrilG'] + this.data['mayoG'] + this.data['junioG']).toFixed(2);
        //             this.casilla03 = ((parseFloat(this.casilla01) - parseFloat(this.casilla02)).toFixed(2)).toString();
        //             this.casilla04 = (((20 / 100) * parseFloat(this.casilla03)).toFixed(2)).toString();
        //             var tmp06 = parseFloat(this.data['abrilIRPF']) + parseFloat(this.data['mayoIRPF']) + parseFloat(this.data['junioIRPF']);
        //             this.casilla06 = Math.abs(tmp06).toFixed(2);
        //             this.casilla07 = ((parseFloat(this.casilla04) - parseFloat(this.casilla05) - parseFloat(this.casilla06)).toFixed(2)).toString();
        //         }

        //         if (this.selectedTrimester == 3) // Tercer Trimestre Julio, Agosto, Septiembre
        //         {
        //             this.casilla01 = (this.data['julioI'] + this.data['agostoI'] + this.data['septiembreI']).toFixed(2);
        //             this.casilla02 = (this.data['julioG'] + this.data['agostoG'] + this.data['septiembreG']).ToFixed(2);
        //             this.casilla03 = ((parseFloat(this.casilla01) - parseFloat(this.casilla02)).toFixed(2)).toString();
        //             this.casilla04 = (((20 / 100) * parseFloat(this.casilla03)).toFixed(2)).toString();
        //             var tmp06 = parseFloat(this.data['julioIRPF']) + parseFloat(this.data['agostoIRPF']) + parseFloat(this.data['septiembreIRPF']);
        //             this.casilla06 = Math.abs(tmp06).toFixed(2);
        //             this.casilla07 = ((parseFloat(this.casilla04) - parseFloat(this.casilla05) - parseFloat(this.casilla06)).toFixed(2)).toString();
        //         }

        //         if (this.selectedTrimester == 4) // Cuarto Trimestre Octubre, Noviembre, Diciembre
        //         {
        //             this.casilla01 = (this.data['octubreI'] + this.data['noviembreI'] + this.data['diciembreI']).ToFixed(2);
        //             this.casilla02 = (this.data['octubreG'] + this.data['noviembreG'] + this.data['diciembreG']).ToFixed(2);
        //             this.casilla03 = ((parseFloat(this.casilla01) - parseFloat(this.casilla02)).toFixed(2)).toString();
        //             this.casilla04 = (((20 / 100) * parseFloat(this.casilla03)).toFixed(2)).toString();
        //             var tmp06 = parseFloat(this.data['octubreIRPF']) + parseFloat(this.data['noviembreIRPF']) + parseFloat(this.data['diciembreIRPF']);
        //             this.casilla06 = Math.abs(tmp06).toFixed(2);
        //             this.casilla07 = ((parseFloat(this.casilla04) - parseFloat(this.casilla05) - parseFloat(this.casilla06)).toFixed(2)).toString();
        //         }

        //         this.spinner = false;
        //         this.ready = true;
        //     })
        // }
    }

    generateModel() {
        if (this.user != null && this.user.isAdmin) {
            let noError = true;

            if (this.selectedTrimester == null || this.selectedTrimester == 0) {
                noError = false;
            }
            if (this.selectedModel == null || this.selectedModel == 0) {
                noError = false;
            }


            if (noError) {
                this.fiscalModel.trimester = this.selectedTrimester;
                this.fiscalModel.model = this.selectedModel;
                this.spinner = true;

                this.fiscalService.getFiscalModel(this.fiscalModel).then(response => {
                    this.spinner = false;
                });
            }
        } else {
            alert("Esta utilidad se encuentra actualmente en desarrollo. \nEstará disponible próximamente.");
        }
    }
}